import { ComponentStateMessage } from "@redotech/redo-model/conversation/conversation-message-db-parser";

interface ToolResultInfo {
  output?: string;
  isError?: boolean;
}

interface ConfirmedStateContent {
  title: string;
  subtitle: string;
}

export function getToolResultInfo(
  message: ComponentStateMessage,
): ToolResultInfo | undefined {
  return message.confirmationStateInformation?.toolResult;
}

export function hasToolError(message: ComponentStateMessage): boolean {
  return getToolResultInfo(message)?.isError ?? false;
}

export function getToolOutput(
  message: ComponentStateMessage,
): string | undefined {
  return getToolResultInfo(message)?.output;
}

export function getConfirmedStateContent(
  message: ComponentStateMessage,
  successTitle: string,
  errorTitle: string,
  defaultSubtitle: string,
): ConfirmedStateContent {
  const toolOutput = getToolOutput(message);
  const hasError = hasToolError(message);

  return {
    title: hasError ? errorTitle : successTitle,
    subtitle: toolOutput || defaultSubtitle,
  };
}
